<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="title">Personal Details</h4>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <form id="travellerInfo">
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Passport Number</label>
              <md-input
                type="text"
                v-model="travellerInfo.passport_number"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <h6>Dietary Information</h6>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Any Relevant Dietary Information?</label>
              <md-textarea
                v-model="travellerInfo.dietary_info"
                md-autogrow
              ></md-textarea>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <h6>Medical Information</h6>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Any Relevant Medical Information?</label>
              <md-textarea
                v-model="travellerInfo.medical_info"
                md-autogrow
              ></md-textarea>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <h6>Emergency Contact Information</h6>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Contact Name</label>
              <md-input
                type="text"
                v-model="travellerInfo.emergency_contact_name"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Contact Number</label>
              <md-input
                type="text"
                v-model="travellerInfo.emergency_contact_number"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Relationship to you</label>
              <md-input
                type="text"
                v-model="travellerInfo.emergency_relationship"
              />
            </md-field>
          </div>

          <div class="md-layout-item md-size-100 text-right">
            <md-button
              class="md-raised md-success mt-4"
              @click.prevent="saveTravellerInfo"
              >Update</md-button
            >
          </div>
        </div>
      </form>
    </md-card-content>
  </md-card>
</template>
<script>
import customerApi from "@/services/api/customer";

export default {
  props: ["customer"],

  data() {
    return {
      travellerInfo: {}
    };
  },

  methods: {
    getTravellerInfo() {
      customerApi
        .getTravellerInfo(this.customer)
        .then(resp => {
          this.travellerInfo = resp.data;
        })
        .catch(err => {});
    },

    saveTravellerInfo() {
      let data = this.travellerInfo;

      customerApi
        .saveTravellerInfo(this.customer, data)
        .then(resp => {
          this.travellerInfo = resp.data;
          this.$notify({
            timeout: 2500,
            message: "Traveller Info has been updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          //console.log(err.response);
        });
    }
  },

  mounted() {
    this.getTravellerInfo();
  }
};
</script>
<style lang="scss" scoped>
#travellerInfo h6 {
  margin-bottom: 0;
}
</style>
